import AOS from "aos";
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";
import Cookies from "../../node_modules/js-cookie/src/js.cookie.js";
import { each } from "jquery";
//import $ from 'jquery';
//import jqueryui from 'jquery';

(function ($) {
    ("use strict");

    // Allow us to add a fade-in class in Gutenberg to trigger AOS animations
    jQuery(".fade-up").attr("data-aos", "fade-up");
    jQuery(".fade-right").attr("data-aos", "fade-right");

    // AOS Init
    AOS.init({
        once: true,
    });

    // Init
    navToggle();
    notificationBar();
    testimonialsSlider();
    homepage();
    valuesSlick();
    slideText();
    ctaParallax();
    headerBannerParallax();

    $(window).on("load", function () {
        staffList();
        anglesAnimations();
    });

    function navToggle() {
        $(".navicon").click(function () {
            $("body").toggleClass("nav-is-active");
        });
    }

    function notificationBar() {
        var cookieName = $('input[name="cookie_name"]').val(),
            cookieExpire = $('input[name="cookie_expire_date"]').val(),
            notificationBar = $(".notification-bar"),
            showBar = true,
            expires = {};

        if (cookieExpire) {
            cookieExpire = cookieExpire.split("-");
            var cookieExpireDate = new Date(
                cookieExpire[0],
                cookieExpire[1] - 1,
                cookieExpire[2]
            );
            expires = { expires: cookieExpireDate };
        }

        // Don't show the bar if the user has already closed it
        if ("hide" === Cookies.get(cookieName)) {
            showBar = false;
        }

        // Show the bar
        if (notificationBar.length > 0 && true === showBar) {
            notificationBar.slideToggle();
        }

        // Hide the bar and create a cookie if needed
        $(".notification-close").click(function (e) {
            e.preventDefault();
            notificationBar.slideToggle();

            if (cookieName) {
                Cookies.set(cookieName, "hide", expires);
            }
        });
    }

    // homepage()
    // - Homepage Parent Function
    function homepage() {
        if ($("body.home").is("*")) {
            wrapGreyArea();
            aboutUsParallax();
            hpAnimations();
        }
    }

    // testimonialsSlider() -
    // - run slick slider on testimonials if it exists
    function testimonialsSlider() {
        if ($(".testimonials").is("*")) {
            var $jq = jQuery.noConflict();
            $jq(".testimonials").slick({
                slidesToShow: 1,
                slidestoScroll: 1,
                dots: true,
                arrows: true,
            });
        }
    }

    // wrapGreyArea() -
    // - wraps the testimonials and featured posts in a grey background
    // - adds element with animated lines
    // - adds animation to grey lines
    function wrapGreyArea() {
        if (
            $(".testimonials-wrapper").is("*") ||
            $(".fposts-wrapper").is("*")
        ) {
            $(".testimonials-wrapper, .fposts-wrapper").wrapAll(
                '<div class="grey-wrapper"></div>'
            );
            $(".grey-wrapper").append('<div class="lines"></div>');
            $(window).on("scroll", function () {
                var y = $(window).scrollTop(),
                    x = $(".grey-wrapper .lines").offset().top - 2000;
                if (y > x) {
                    $(".grey-wrapper .lines")
                        .addClass("fadeInUp")
                        .removeClass("fadeOutDown");
                } else {
                    $(".grey-wrapper .lines")
                        .removeClass("fadeInUp")
                        .addClass("fadeOutDown");
                }
            });
        }
    }

    // anglesAnimations -
    // - animation functions for the Angled Content block
    function anglesAnimations() {
        if ($(".angle-block-wrapper").is("*")) {
            const anims = document.querySelectorAll(
                ".angle-block-wrapper .wp-block-column .animated"
            );
            anims.forEach((anim) => {
                gsap.to(anim, {
                    scrollTrigger: anim,
                    opacity: 1,
                    duration: 2,
                    x: -300,
                });
            });
        }
    }

    // hpAnimations -
    // - animation functions for the first content block and About Us on homepage
    function hpAnimations() {
        if ($(".animated-block-wrapper").is("*")) {
            const anims = document.querySelectorAll(
                ".animated-block-wrapper .wp-block-column .animated"
            );
            anims.forEach((anim) => {
                gsap.to(anim, {
                    scrollTrigger: anim,
                    opacity: 1,
                    duration: 2,
                    x: -300,
                });
            });
        }
        if ($(".aboutus-wrapper .animated").is("*")) {
            const anims = document.querySelectorAll(
                ".aboutus-wrapper .animated"
            );
            anims.forEach((anim) => {
                gsap.to(anim, {
                    scrollTrigger: anim,
                    opacity: 1,
                    duration: 2,
                    x: -300,
                });
            });
        }
    }

    // Testimonial Slideshow
    function testimonialSlideShow() {
        if ($(".b40-testimonials-slider").length <= 0) {
            return;
        }

        var slider = tns({
            container: ".b40-testimonials-slider",
            controls: false,
            navPosition: "bottom",
        });
    }

    // staffList() -
    // - if the staff list block exists, adds dialog to each staff member that has a bio
    function staffList() {
        if ($(".staff-list").is("*")) {
            $(".hasdialog .staff-lightbox").each(function () {
                var par = $(this).closest(".hasdialog"),
                    box = $(this),
                    close = $(this).find(".close-icon"),
                    mod = box.dialog({
                        modal: true,
                        autoOpen: false,
                        width: 950,
                    });
                par.on("click", function () {
                    mod.dialog("open");
                });
                close.on("click", function () {
                    mod.dialog("close");
                });
            });
            $(window).on("scroll", function () {
                var y = $(window).scrollTop(),
                    x = $(".staff-wrapper .lines").offset().top - 2000;
                if (y > x) {
                    $(".staff-wrapper .lines")
                        .addClass("fadeInUp")
                        .removeClass("fadeOutDown");
                } else {
                    $(".staff-wrapper .lines")
                        .removeClass("fadeInUp")
                        .addClass("fadeOutDown");
                }
            });
        }
    }

    // valuesSlick() -
    // - runs slick slider on the Guiding Principles/Values block
    // - two instances of slick - one for background images, one for the text blocks
    function valuesSlick() {
        if ($(".values-list").is("*")) {
            $(".value-images").slick({
                asNavFor: ".value-blocks",
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 1200,
                slidesToShow: 1,
                fade: true,
                arrows: false,
            });

            $(".value-blocks").slick({
                asNavFor: ".value-images",
                //infinite: false,
                speed: 1200,
                //fade: true,
                focusOnSelect: true,
                arrows: false,
                buttons: false,
                responsive: [
                    {
                        breakpoint: 3000,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 1,
                            //centerMode: true,
                        },
                    },
                ],
            });
        }
    }

    // headerBannerParallax() -
    // - adds parallax to interior pages' headers
    function headerBannerParallax() {
        if ($(".header-banner-wrap .title-wrap").is("*")) {
            $(".header-banner-wrap .title-wrap .parallax").parallax({
                imageSrc:
                    "/wp-content/themes/TriCorps-Theme-2021/images/header-bg.jpg",
            });
        }
    }

    // ctaParallax() -
    //
    function ctaParallax() {
        if ($(".b40-cta").is("*")) {
            var img = $(".b40-cta .cta-bg").attr("data-image");
            $(".b40-cta").parallax({
                imageSrc: img,
                speed: 0.5,
                bleed: 50,
            });
        }
    }

    // aboutUsParallax() -
    //
    function aboutUsParallax() {
        if ($(".aboutus-wrapper").is("*")) {
            $(".aboutus-wrapper .parallax").parallax({
                imageSrc:
                    "/wp-content/themes/TriCorps-Theme-2021/images/header-bg.jpg",
            });
        }
    }

    // slideText() -
    // - this function helps with the homepage hero text animation
    // - calculates the height of the .b40-hero-headline element
    // - based on that height, wraps each line break the browser creates in a span and a div
    function slideText() {
        if ($(".b40-hero-headline").is("*")) {
            var cont = $(".b40-hero-headline h1");

            var text_arr = cont.text().split(" ");
            var i = 0;
            for (i = 0; i < text_arr.length; i++) {
                text_arr[i] = "<span>" + text_arr[i] + " </span>";
            }

            cont.html(text_arr.join(""));

            var wordSpans = cont.find("span");

            var lineArray = [],
                lineIndex = 0,
                lineStart = true,
                lineEnd = false;

            wordSpans.each(function (idx) {
                var pos = $(this).position();
                var top = pos.top;

                if (lineStart) {
                    lineArray[lineIndex] = [idx];
                    lineStart = false;
                } else {
                    var next = $(this).next();

                    if (next.length) {
                        if (next.position().top > top) {
                            lineArray[lineIndex].push(idx);
                            lineIndex++;
                            lineStart = true;
                        }
                    } else {
                        lineArray[lineIndex].push(idx);
                    }
                }
            });

            for (i = 0; i < lineArray.length; i++) {
                var start = lineArray[i][0],
                    end = lineArray[i][1] + 1;

                /* no end value pushed to array if only one word last line*/
                if (!end) {
                    wordSpans
                        .eq(start)
                        .wrap(
                            '<div class="line_outer"><span class="line_wrap"></span></div>'
                        );
                } else {
                    wordSpans
                        .slice(start, end)
                        .wrapAll(
                            '<div class="line_outer"><span class="line_wrap"></span></div>'
                        );
                }
            }
            $(".b40-hero-headline h1").addClass("animate");
        }
    }
})(jQuery);
